module.exports = __webpack_public_path__ + "img/austria-transport-accidents-male.7ba1bd40.png";